import Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import LodgingReservation from '../../schema/LodgingReservation';
import assignAddress from './assignAddress';
import checkEntityArray from './checkEntityArray';
import setReservationEntityData from './setReservationEntityData';

/**
 * parse data for Lodging Entity
 */
export default function setLodgingReservationEntityData(
    entity: Entity,
    lodgingEntity: any,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
): LodgingReservation {
    if (entity && lodgingEntity) {
        if (isLodgingReservationValid(lodgingEntity, entity, isValidDate)) {
            let newLodgingEntity: LodgingReservation = setReservationEntityData(
                entity,
                lodgingEntity,
                true /* isReservationIdRequired */
            );

            newLodgingEntity = {
                ...newLodgingEntity,
                ...{
                    entityName: EntityTypeNames.LodgingReservation,
                    entityType: EntityType.LodgingReservation,
                    checkinTime: lodgingEntity.checkinTime,
                    checkoutTime: lodgingEntity.checkoutTime,
                    checkinTimeUTC: lodgingEntity['checkinTime/utc'],
                    checkoutTimeUTC: lodgingEntity['checkoutTime/utc'],
                    lodgingBusiness: {},
                },
            };

            const lodgingBusiness = checkEntityArray(newLodgingEntity.lodgingBusiness);

            // assign address
            lodgingBusiness.address = assignAddress({}, lodgingEntity.reservationFor.address);
            lodgingBusiness.name = lodgingEntity.reservationFor.name;
            lodgingBusiness.telephone = lodgingEntity.reservationFor.telephone;

            return newLodgingEntity;
        }
    }
    return null;
}

export function isLodgingReservationValid(
    lodgingEntity: any,
    entity: Entity,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
) {
    if (lodgingEntity) {
        const isDateValidUsingCallback: boolean = isValidDate
            ? isValidDate(lodgingEntity.checkinTime, false /* isUtcTime*/, entity) &&
              isValidDate(lodgingEntity.checkoutTime, false /* isUtcTime*/, entity)
            : true;

        if (
            lodgingEntity.checkinTime &&
            lodgingEntity.checkoutTime &&
            lodgingEntity.reservationFor &&
            isDateValidUsingCallback
        ) {
            return true;
        }
    }
    return false;
}
